import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const Navbar = () => {
  const location = useLocation();

  const links = [
  { label: 'Home', to: '/' },
  { label: 'How it works', to: '/how-it-works' },
  { label: 'Whitepaper', to: '/whitepaper' },
  { label: 'Outcomes', to: '/#outcomes' }];


  const handleOutcomes = (e) => {
    e.preventDefault();
    if (location.pathname === '/') {
      const el = document.getElementById('outcomes');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = '/#outcomes';
    }
  };

  return (
    <nav className="cy-nav">
      <Link to="/" className="cy-logo">
        <span className="cy-logo-care !text-[#C4A128]">Care</span>
        <span className="cy-logo-yield">Yield</span>
      </Link>

      <div className="cy-nav-links">
        {links.map((link) =>
        link.label === 'Outcomes' ?
        <a
          key={link.label}
          href={link.to}
          onClick={handleOutcomes}
          className="cy-nav-link">

              {link.label}
            </a> :

        <Link
          key={link.label}
          to={link.to}
          className={`cy-nav-link${location.pathname === link.to ? ' active' : ''}`}>

              {link.label}
            </Link>

        )}
      </div>

      <Link to="/contact" className="cy-nav-cta">
        Request a demo
        <ArrowRight size={13} strokeWidth={2.5} />
      </Link>
    </nav>);

};

export default Navbar;